import { ReactNode } from 'react';
import { Card, CardBody } from 'react-bootstrap';

type InformationCardTemplateProps = {
  icon: ReactNode;
  backgroundColor: string;
  borderColor: string;
  primaryText: string;
  secondaryText: string;
  dataTest?: string;
};

export default function InfoCardTemplate({
  icon,
  backgroundColor,
  borderColor,
  primaryText,
  secondaryText,
  dataTest,
}: InformationCardTemplateProps) {
  return (
    <Card
      bg={backgroundColor}
      data-test={dataTest}
      className="border-0 overflow-hidden position-relative"
    >
      {/* Cannot use border because inner radius will be rounded */}
      <div
        className={`bg-${borderColor} position-absolute top-0 start-0 h-100`}
        style={{ width: '4px' }}
      />
      <CardBody>
        {/* Have to use divs instead of bootbox grid because Alison's spacing is smaller than what bootbox allows */}
        <div>
          <div className="d-flex align-items-center">
            <div
              className="d-flex align-items-center justify-content-center flex-shrink-0"
              style={{ width: '2rem' }}
            >
              {icon}
            </div>
            <div style={{ paddingLeft: '0.5rem' }}></div>
            <div className="d-flex flex-column justify-content-center flex-grow-1">
              <h6 className="mb-1">{primaryText}</h6>
            </div>
          </div>
          <div style={{ paddingLeft: '2.5rem' }}>
            <p
              className="mb-0 text-gray-500"
              style={{ whiteSpace: 'pre-line' }}
            >
              {secondaryText}
            </p>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}
